export default __webpack_public_path__ + "static/media/insomniac.88794363.svg";